// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip___t2hW"};